import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authenticationReducer from 'src/state/authentication/reducer'
import catalogReducer from 'src/state/catalog/reducer'
import legalWritingReducer from 'src/state/legalWriting/reducer'

const appReducer = combineReducers({
  authentication: authenticationReducer,
  legalWriting: legalWritingReducer,
  catalog: catalogReducer
})

export type State = ReturnType<typeof appReducer>

function rootReducer(state, action) {
  if (action.type === 'RESET_STATE') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export default configureStore({
  reducer: rootReducer,
  devTools: true
})
